import {getSettings} from '../selectors/selectors';
import store from '../store/store';

class googleMapUtils {
  static addressFormatter(rawAddress) {
    const addressArray = [];
    
    if (rawAddress.organisationName !== rawAddress.buildingNameNumber) {
      const countriesWithHouseNumberSecond = ['DE', 'IT'];
      if (countriesWithHouseNumberSecond.includes(rawAddress.countryCode)) {
        addressArray.push(`${rawAddress.line1} ${rawAddress.buildingNameNumber}`);
      } else {
        addressArray.push(`${rawAddress.buildingNameNumber} ${rawAddress.line1}`);
      }
    } else {
      addressArray.push(rawAddress.line1);
    }
    addressArray.push(rawAddress.line2);
    addressArray.push(rawAddress.line3);
    addressArray.push(rawAddress.line4);
    addressArray.push(rawAddress.postcode);
    
    // Remove empty values and join with comma
    const trimmedArray = addressArray.map(item => item.trim());
    return trimmedArray.filter(item => item).join(', ');
  }
  
  static loadGoogleMaps() {
    return new Promise((resolve, reject) => {
      
      if (getSettings(store.getState()).should_load_google_maps_if_script_already_added) {
        const googleApiScript = document.createElement('script');
  
        window.googleMapsCallback = () => {};
  
        // eslint-disable-next-line max-len
        googleApiScript.src = 'https://maps.google.com/maps/api/js?key=AIzaSyCmIAOBM-PT8QjQ0m4l7WD4cAOC_nqrVd8&callback=googleMapsCallback&libraries=places';
        document.head.appendChild(googleApiScript);
  
        googleApiScript.onload = resolve;
        googleApiScript.onerror = reject;
        
      } else {
        // eslint-disable-next-line max-len
        const src = 'https://maps.google.com/maps/api/js?key=AIzaSyCmIAOBM-PT8QjQ0m4l7WD4cAOC_nqrVd8&callback=googleMapsCallback&libraries=places';
  
        if(!document.querySelector(`script[src="${src}"]`)) {
          const googleApiScript = document.createElement('script');
    
          window.googleMapsCallback = () => {};
          googleApiScript.src = src;
          document.head.appendChild(googleApiScript);
          googleApiScript.onload = resolve;
          googleApiScript.onerror = reject;
        } else {
          resolve()
        }
      }
    });
  }
}

export default googleMapUtils;
